import React from "react";
import Modal from "react-bootstrap/Modal";
import { Button } from "../../common/Button";
import { formatRange } from "./time";
import { timeZoneLabel } from "./timeZones";

export default function WorkingHoursDetailModal({ window, categories = [], timezoneName, canEdit, onHide, onEdit, onBlock }) {
  const categoryIds = [...new Set(window.serviceCategoryIds || [])];

  return (
    <Modal show onHide={onHide} centered className="custom-dialog scheduling-dialog" aria-labelledby="working-hours-title">
      <Modal.Header closeButton>
        <Modal.Title id="working-hours-title">Working hours</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-0">{formatRange(window.startsAt, window.endsAt, timezoneName)}</p>
        <p className="schedule-help">{timeZoneLabel(timezoneName)} time</p>
        <section className="working-hours-types" aria-labelledby="working-hours-types-title">
          <h3 id="working-hours-types-title">Appointment types</h3>
          {categoryIds.length ? (
            <ul>
              {categoryIds.map((id) => {
                const category = categories.find((item) => item.serviceCategoryId === id);
                return (
                  <li key={id}>
                    <span>{category?.name || "Appointment type unavailable"}{category?.organizationRef ? ` · ${category.organizationName || category.organizationRef}` : ""}</span>
                    {category?.durationMinutes > 0 && <span className="working-hours-type-duration">{category.durationMinutes} min</span>}
                  </li>
                );
              })}
            </ul>
          ) : <p className="mb-0">No appointment types assigned.</p>}
        </section>
      </Modal.Body>
      {canEdit && (
        <Modal.Footer className="schedule-dialog-footer">
          <Button variant="secondary" onClick={() => onEdit(window)}>Edit hours</Button>
          <Button onClick={() => onBlock(window)}>Block time</Button>
        </Modal.Footer>
      )}
    </Modal>
  );
}
